module.exports = __webpack_public_path__ + "static/img/student.e6fb237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/student.png
// module id = vFCM
// module chunks = 1